module.exports = __webpack_public_path__ + "img/home_profile.3329de94.svg";